import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ApplicationErrorFallback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Result
      status="500"
      title={t('errorBoundary.somethingWentWrong')}
      subTitle={t('errorBoundary.anUnexpectedErrorOccurred')}
      extra={[
        <Button type="primary" key="home" onClick={goBack}>
          {t('errorBoundary.goBack')}
        </Button>,
      ]}
    />
  );
};

export default ApplicationErrorFallback;
